<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="400"
          :auto-resize="true"
          :data="tableData"
          :edit-rules="formRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column width="40" v-if="add" align="center">
          <template v-slot:header>
            <Button class="add-btn" icon="md-add" @click="insertEvent()"></Button>
          </template>
          <template v-slot="{ row,$rowIndex }">
            <Button class="del-btn" icon="md-remove" @click="removeEvent(row,$rowIndex)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bankAccountType" title="账户类型">
          <template v-slot="{ row }">
            <vxe-select v-model="row.bankAccountType" placeholder="请选择" :options="accountTypeList"
                        @change="(file) => changeType(file,row)"
                        transfer></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="accountName" title="账户名称" width="300">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.accountName"
                placeholder="必填"
                @blur="clearTableV"
                @input="$refs.xTable.updateStatus(scope)"
                v-if="scope.row.bankAccountType === 1"
            ></vxe-input>
            <platform-corp :row="scope.row" :field="'accountName'" :placeholder="'选择平台企业'" v-else></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bankName" title="开户行" width="300">
          <template v-slot="{ row }">
            <select-bank-name :row="row"></select-bank-name>
          </template>
        </vxe-table-column>
        <vxe-table-column field="accountNum" title="银行账号" width="300">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.accountNum"
                placeholder="必填"
                @blur="clearTableV"
                @input="(file)=>checkAcc(file,scope.row)"
            ></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="close">取 消</Button>
      <Button status="primary" @click="commit">提 交</Button>
    </div>
  </div>
</template>

<script>
import $C from "@/consts/index";
import PlatformCorp from "@/components/common/PlatformCorp";
import $api from "@/apiProvider";
import SelectBankName from "@/components/finance/SelectBankName";

export default {
  components: {PlatformCorp, SelectBankName},
  data() {
    return {
      add: true,
      formRules: {
        companyName: [{required: true, message: "请选择所属公司"}],
        accountNum: [{required: true, message: "请输入账户号"}, {max: 30, message: '请输入正确的银行账户'}],
        accountName: [{required: true, message: "请输入账户名称"}],
        bankAccountType: [{required: true, message: "请选择"}]
      },
      tableData: [
        {
          id: '',
          companyName: null, //企业名称
          bankName: null, //开户行
          openBankName: null,
          openOrgNum: null,
          accountNum: null, //账户号
          accountName: null, //户名
          bankAccountType: null //账户类型
        }
      ],
      accountTypeList: [{
        label: '现金账户',
        value: 1
      }, {
        label: '银行账户（一般户）',
        value: 2
      }, {
        label: '银行账户（基本户）',
        value: 3
      }, {
        label: '汇票账户',
        value: 4
      }],
      visible: false,
      info: {},
    };
  },
  created() {
  },
  methods: {
    checkAcc(e, row) {
      row.accountNum = e.replace(/[^\d]/g, '');
    },
    changeType(e, row) {
      row.bankAccountType = e.value;
      // row.accountName = null;
    },
    setData(data) {
      this.add = false;
      this.tableData[0].id = data.id;
      this.tableData[0].companyName = data.companyName;
      this.tableData[0].bankName = data.bankName;
      this.tableData[0].openBankName = data.openBankName;
      this.tableData[0].openOrgNum = data.openOrgNum;
      this.tableData[0].accountNum = data.accountNum;
      this.tableData[0].accountName = data.accountName;
      this.tableData[0].bankAccountType = data.bankAccountType;
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    async insertEvent(row) {
      let record = {
        companyName: null, //企业名称
        bankName: null, //开户行
        openBankName: null,
        openOrgNum: null,
        accountNum: null, //账户号
        accountName: null, //户名
        bankAccountType: null //账户类型
      };
      let {row: newRow} = await this.$refs.xTable.insertAt(record, row);
      this.$refs.xTable.data.push(record);
      await this.$refs.xTable.setActiveCell(newRow, "companyName");
    },
    removeEvent(row, i) {
      this.$refs.xTable.remove(row);
      this.$refs.xTable.data.splice(i, 1);
    },
    async validEvent() {
      let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    async commit() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return
      }
      let res = await $api.platformCorp.post("createPlatformCompany", {data: this.tableData});
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    close() {
      this.add = true;
      this.tableData = [
        {
          id: '',
          companyName: null, //企业名称
          bankName: null, //开户行
          // openOrgNum: null,
          accountNum: null, //账户号
          accountName: null, //户名
          bankAccountType: null //账户类型
        }
      ];
      this.bankList = [];
      this.clearTableV();
      this.$emit('close');
    }
  }
};
</script>

<style>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1:hover {
  background-color: #f5f7fa;
}
</style>
